export default "__VITE_ASSET__C32tuDVe__"